import { useStatQuery } from '@famly/stat_use-stat-query';
import { KinderConnectCaptureRequired } from './kinder-connect-capture-required.query';
/**
 * Fetches whether KinderConnect TWC media capture (photo, signature, GPS) is required for a
 * check-in/check-out submission covering the given children. True if it's required for *any* of
 * them (computed server-side). An empty `childIds` array, an id that doesn't resolve to a child,
 * or a permission gap on any of the children are all hard errors from the backend, not `false` --
 * feed the result into `useIsKinderConnectCaptureEnabledForChildren` from
 * `@famly/stat_kinder-connect-capture_business-logic` rather than reading `data`/`error` directly.
 *
 * @param options - Apollo query options; must include `variables: {childIds}`.
 * @returns The query result, with `data.attendance.childCheckins.kinderConnectCaptureRequired`
 * holding the boolean once loaded.
 */
export function useKinderConnectCaptureRequiredQuery(options) {
    return useStatQuery(KinderConnectCaptureRequired, options);
}
